import React from 'react';
import { CloseIcon, QuestionOutlineIcon } from '@chakra-ui/icons';
import { Box, Button, Flex, IconButton, Link, Spinner, Text } from '@chakra-ui/react';
import ModalTemplate from '@components/modalTemplate';

export default function ModalConfirmTemplate({
    children,
    isOpen = false,
    onClose = () => {},
    onSubmit = () => {},
    width = '800px',
    borderRadius = '12px',
    isClosebyOverlayClick = false,
    modalTitle = 'Tambah Produk',
    btnTitleCancel = 'Batal',
    btnTitleSubmit = 'Simpan',
    isCentered = false,
    isCenterBtn = false,
    isHelperText = false,
    isLoading = false,
}) {
    return (
        <ModalTemplate
            isOpen={isOpen}
            width={width}
            onClose={onClose}
            borderRadius={borderRadius}
            isClosebyOverlayClick={isClosebyOverlayClick}
            isCentered={isCentered}
        >
            <Box p={'24px'}>
                <Flex mb={'12px'} justifyContent={'space-between'} alignItems={'center'}>
                    <Flex alignItems={'center'} gap={'18px'}>
                        <Text fontWeight={'600'} fontSize={'24px'}>
                            {modalTitle}
                        </Text>

                        {isHelperText && (
                            <Text
                                color={'paragon.600'}
                                fontSize={'13px'}
                                display={'flex'}
                                alignItems={'center'}
                                gap={'4px'}
                                fontWeight={'bold'}
                                as={Link}
                                href="https://sagitarius.id/panduan-mapping-produk/"
                                target="_blank"
                            >
                                <QuestionOutlineIcon mb={1} />
                                Temukan Panduan Mapping Disini!
                            </Text>
                        )}
                    </Flex>

                    <IconButton onClick={onClose} variant={'unstyled'}>
                        <CloseIcon fontSize={'14px'} />
                    </IconButton>
                </Flex>

                <Box>{children}</Box>

                <Flex justifyContent={isCenterBtn ? 'center' : 'end'} mt={'18px'} gap={'12px'}>
                    <Button onClick={onClose} p={'18px 52px !important'} variant={'outline'} w={'170px'}>
                        {btnTitleCancel}
                    </Button>
                    <Button p={'18px 52px !important'} onClick={onSubmit} disabled={isLoading} w={'170px'}>
                        {isLoading ? <Spinner /> : btnTitleSubmit}
                    </Button>
                </Flex>
            </Box>
        </ModalTemplate>
    );
}
